import fetch from "@/utils/request";


// 下载App
export default {
  getDownUrl(data?: object, config = {}):any {
    return fetch({
      url: '/php/api/tools/get_app_info',
      method: 'get',
      data,
      ...config
    })
  }
}